import { NavLink } from "react-router-dom";
import React, { useState,useEffect } from "react";
export default function PageNotFound(){
     useEffect(() => {
        document.title = "Page Not Found | Oriflamme IT Solutions";
      }, []);

    return(
        <div className="d-flex align-items-center justify-content-center">
            <div className="text-center my-5">
            <h3>
            Page Not Found
            </h3>
            <NavLink to="/">Go to Home</NavLink>
            </div>
        </div>
    );
}